<template>
  <div class="rt-sub-section">
    <div class="rt-sub-section-header">
      <p class="rt-sub-section-title">{{ title }}</p>
    </div>
    <div v-if="$slots.default" class="rt-sub-section-body"><slot /></div>
  </div>
</template>
<script>
export default {
  name: 'RtSubSection',
  props: {
    title: String
  }
};
</script>



// WEBPACK FOOTER //
// rtSubSection.vue?4d43b31e